"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var Highlight = function Highlight(props) {
  var children = props.children,
    value = props.value,
    color = props.color,
    backgroundColor = props.backgroundColor,
    render = props.render;
  var child = (0, _react.useMemo)(function () {
    return render ? render(value, color, backgroundColor) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        color: color,
        backgroundColor: backgroundColor
      },
      children: value
    });
  }, [color, backgroundColor, value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [children, value && child]
  });
};
var KeywordsInner = function KeywordsInner(props) {
  var children = props.children,
    _props$caseIgnored = props.caseIgnored,
    caseIgnored = _props$caseIgnored === void 0 ? true : _props$caseIgnored,
    _props$color = props.color,
    color = _props$color === void 0 ? 'inherit' : _props$color,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? '#ffff00' : _props$backgroundColo,
    value = props.value,
    render = props.render;
  if (typeof children !== 'string') return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: children
  });
  var splitMatch = new RegExp((value || '').replace(/\\/g, '\\\\'), caseIgnored ? 'ig' : 'g');
  var values = value ? children.match(splitMatch) : [];
  var matched = children.split(splitMatch);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: matched.map(function (item, idx) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Highlight, {
        color: color,
        value: matched.length > idx + 1 ? values[idx] : undefined,
        render: render,
        backgroundColor: backgroundColor,
        children: item
      }, idx);
    })
  });
};
var _default = exports["default"] = KeywordsInner;
module.exports = exports.default;